import { Routes } from '@angular/router';
import { ClinicNavigationEnum } from '@core/enums/navigation.enum';
import { ClinicComponent } from './clinic.component';
import { CalendarComponent } from './pages/calendar/calendar.component';
import { doctorOfficeRoutes } from './pages/doctor-office/doctor-office.routes';
import { patientExaminationCardRoutes } from './pages/examination-card/examination-card.routes';
import { ClinicHomeComponent } from './pages/home/home.component';
import { settingsRoutes } from './pages/settings/settings.routes';
import { ClinicSignInComponent } from './pages/sign-in/sign-in.component';
import { StaffInfoComponent } from './pages/staff-info/staff-info.component';
import { telediagnosisOldRoutes } from './pages/telediagnosis-old/telediagnosis-old.routes';
import { doctorAssistantRoutes } from './pages/physician-assistant/doctor-assistant.routes';
import { telediagnosisRoutes } from './pages/telediagnosis/telediagnosis.routes';
import { canActivateAuthStaff } from '@core/guards/auth-staff.guard';

export const clinicRoutes: Routes = [
  { path: 'sign-in', component: ClinicSignInComponent },
  {
    path: '',
    component: ClinicComponent,
    canActivate: [canActivateAuthStaff],
    children: [
      { path: '', redirectTo: '', pathMatch: 'full' },
      {
        path: '',
        component: ClinicHomeComponent,
      },
      {
        path: ClinicNavigationEnum.calendar,
        component: CalendarComponent,
      },

      {
        path: ClinicNavigationEnum.staff_info,
        component: StaffInfoComponent,
      },
      {
        path: '',
        loadChildren: () =>
          import('./pages/physician-assistant/doctor-assistant.routes').then(() => doctorAssistantRoutes),
      },
      {
        path: '',
        loadChildren: () => import('./pages/settings/settings.routes').then(() => settingsRoutes),
      },
      {
        path: '',
        loadChildren: () => import('./pages/doctor-office/doctor-office.routes').then(() => doctorOfficeRoutes),
      },
      {
        path: '',
        loadChildren: () =>
          import('./pages/telediagnosis-old/telediagnosis-old.routes').then(() => telediagnosisOldRoutes),
      },
      {
        path: '',
        loadChildren: () => import('./pages/telediagnosis/telediagnosis.routes').then(() => telediagnosisRoutes),
      },
      {
        path: '',
        loadChildren: () =>
          import('./pages/examination-card/examination-card.routes').then(() => patientExaminationCardRoutes),
      },
    ],
  },
];
